import { Section } from '../../../sections/builders/section_builder';
import { MultiSectionServant } from '../../servants/multi_section_servant';
import { TermCourseServant } from '../../../term_courses/servants/term_course_servant';
import { ISection, ISectionType } from '../../../../interfaces/scheduler_interfaces';
import { SectionInfoServant, IFormattedSectionTime } from '../../../sections/servants/section_info_servant';
import { ScheduledSectionServant } from '../../servants/scheduled_section_servant';
import { ScheduledSectionTileServant } from '../../servants/scheduled_section_tile_servant';
import * as _4 from 'lodash4';

class MultiSectionMessage {
  private section: ISection;

  private isMultiSection: boolean;
  private courseColor: string;
  private showCourseSectionsRequired: boolean;
  private requiredSectionTypes: ISectionType[];
  constructor(
    private getCSSClassForString: any,
    private ngTermCourseServant: TermCourseServant,
    private ngMultiSectionServant: MultiSectionServant
  ) {}

  initialize() {
    this.isMultiSection = TermCourseServant.isMultiSectionCourse(this.section._course);
    if (this.isMultiSection) {
      const siblingSectionsIDs = _4.map(
        this.ngMultiSectionServant.getScheduledSiblingSections(this.section),
        'section_type'
      );
      this.requiredSectionTypes = _4.uniqBy(
        _4.filter(
          this.section._course._section_types,
          (section_type: ISectionType) =>
            !_4.includes(siblingSectionsIDs, section_type.id) &&
            section_type.is_required &&
            section_type.session === this.section._section_type.session
        ),
        'name'
      );
      this.courseColor = this.getCSSClassForString(this.section._course.nk, 'txt');
    }
  }

  $onInit() {
    this.initialize();
  }

  $onChanges(changes: { section: ISection }) {
    this.initialize();
  }
}

class MultiSectionMessageComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      section: '<',
      additionalSectionsRequiredText: '<?',
      additionalSectionsRequiredErrorMessage: '@?'
    };
    this.controller = MultiSectionMessage;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/multi_section_message/multi_section_message.html';
  }
}
angular.module('capability-ng-scheduler').component('multiSectionMessage', new MultiSectionMessageComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/multi_section_message/multi_section_message.ts